/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { GrantType } from "./GrantType";

export interface EntitlementStateModel {
  entitled: boolean;
  grant_types?: GrantType[];
}
